import { Box, Typography } from '@mui/material';
import Mui from 'materials';
import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useIntl } from 'react-intl';
import { SharedFolder } from '../types/shared-folder.type';

type Props = {
  handleGoBack: () => void;
  folder: SharedFolder | undefined;
};

const PAGE_NAME_ID = 'fileSharing';

const FolderInfo: React.FC<Props> = ({ handleGoBack, folder }) => {
  const intl = useIntl();
  // better way to do this? Goal is to keep arrow and folder path showing current folder until new folder has settled. using state to store the value persists until they can be updated instead of wiping values completely since folder is loading once more on navigation
  const [folderPath, setFolderPath] = useState<string>('');
  const [parentId, setParentId] = useState<string>('');

  useEffect(() => {
    if (!!folder) {
      setFolderPath(folder?.path);
      setParentId(folder.parentFolderId);
    }
  }, [folder?.path]);

  return (
    <Box display={'flex'} gap={2}>
      {!!parentId && (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={4} sx={{ cursor: 'pointer' }}>
          <ArrowLeft size={16} onClick={() => handleGoBack()} />
        </Box>
      )}
      <Box>
        <Typography>
          {intl.formatMessage({ id: `${PAGE_NAME_ID}.currentFolder` })}: {folderPath}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(FolderInfo);
